<template>
  <b-modal v-model="isModalShow" hide-footer centered @hide="hide">
    <template #modal-title>
      <div class="d-md-flex justify-content-between align-items-center w-100">
        บันทึกช่วยจำ
      </div>
    </template>
    <div>
      <b-form-textarea v-model="note" rows="4"></b-form-textarea>
    </div>
    <div class="d-flex justify-content-center mt-4">
      <b-button class=" btn-cancel" @click="hide">ยกเลิก</b-button>
      <b-button
        :disabled="!note"
        class="ml-2 btn-confirm"
        variant="primary"
        @click="onConfirm"
        >บันทึก</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "OrderModalNote",
  data() {
    return {
      isModalShow: false,
      note: ""
    };
  },
  methods: {
    show() {
      this.isModalShow = true;
    },
    hide() {
      this.isModalShow = false;
    },
    onConfirm() {
      this.isModalShow = false;
      this.$emit("onConfirm", this.note);
    }
  },
  mounted() {
    this.note = "";
  }
};
</script>

<style lang="scss" scoped>
.btn-cancel {
  //   background-color: #ffffff !important;
  //   color: #832abf;
  //   border: 1px solid #832abf;
}
.btn-confirm {
  //   background-color: #832abf;
  //   color: #ffffff;
  //   border: 1px solid #832abf;
}
</style>
